<template>
  <div class="modal-mask" @click.stop="reject">
    <div class="modal" @click.stop>
        <h3 class="modal__title">{{ title }}</h3>
        <p class="modal__text" v-if="text">{{ text }}</p>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton :title="confirmButtonTitle" :type="confirmButtonType" @click.native="confirm"/>
          </div>
          <div v-if="rejectButtonType" class="modal__button">
            <AppButton :title="rejectButtonTitle" :type="rejectButtonType" @click.native="reject"/>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import AppButton from '../button/AppButton.vue'

export default {
  name: 'app-modal',
  components: {
    AppButton
  },
  props: {
    title: String,
    text: String,
    confirmButtonType: String,
    confirmButtonTitle: String,
    rejectButtonType: String,
    rejectButtonTitle: String
  },
  data () {
    return {

    }
  },
  methods: {
    confirm () {
      this.$emit('confirm')
    },
    reject () {
      this.$emit('reject')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.modal {
  align-items: center;
  max-width: 450px;
  padding: 25px 20px 20px 20px;

  &__title {
    font-weight: bold;
    color: $color__brown;
    font-size: 18px;
    margin: 0;
    width: 100%;
    max-width: 270px;
    text-align: center;
  }

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-top: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    margin-top: 40px;
  }

  &__button {
    margin-right: 16px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
